import * as React from "react";
import { SVGAttributes } from "react";

export const LectureIcon = React.memo(
  ({
    size = 24,
    color = "#4E5361",
    ...props
  }: SVGAttributes<SVGElement> & {
    size?: number,
  }) => {
    return (
      <svg width={size} height={size} fill="none" {...props}>
        <path
          d="M6.68 6.893A3.446 3.446 0 106.68 0a3.446 3.446 0 000 6.893zm11.709 10.505c0-.07-.012-.137-.021-.205l5.147-3.736a.727.727 0 00-.427-1.313c-.154 0-.3.048-.426.138l-5.157 3.744a1.503 1.503 0 00-.628-.14h-2.803l-.68-3.874c-.374-1.953-1.158-3.487-2.828-3.487h-7.08C1.816 8.525 0 10.342 0 12.012v11.583c0 .835.676 1.512 1.511 1.512h1.056l.574 9.879a1.61 1.61 0 001.61 1.608h3.217c.889 0 1.609-.72 1.609-1.608l.755-19.567h.038l.432 1.909a1.87 1.87 0 001.848 1.581h4.227c.835 0 1.512-.676 1.512-1.511z"
          fill="#9B53C8"
        />
        <path
          d="M15.613 1.191v12.584h1.979V3.17H40.02v18.911H17.59v-2.38h-1.978v4.36H42V1.19H15.613z"
          fill="#9B53C8"
        />
        <path
          d="M25.324 9.23l5.042 1.78V5.658a5.349 5.349 0 00-5.042 3.572z"
          fill="#9B53C8"
        />
        <path
          d="M27.073 14.165a5.35 5.35 0 105.35-5.35v5.35l-5.042-1.778a5.345 5.345 0 00-.308 1.778z"
          fill="#9B53C8"
        />
      </svg>
    );
  }
);
